/**
 * useScorecardNetworkIdle Hook
 *
 * Wraps the core useNetworkIdle hook and sets window.reportPdfGeneration
 * once the network is idle AND the page data has finished loading.
 *
 * Passing isDataLoading prevents Gotenberg from capturing the spinner:
 * even if network idle fires early (e.g. via the maxWait safety net),
 * 'ready' is only signalled once the actual scorecard data is rendered.
 *
 * Backend (Gotenberg) should use waitForExpression: 'window.reportPdfGeneration === "ready"'
 */

import { useEffect } from 'react';
import { useNetworkIdle } from '@/hooks/useNetworkIdle';

declare global {
  interface Window {
    reportPdfGeneration: string;
  }
}

export const useScorecardNetworkIdle = (
  isDataLoading: boolean = false,
  timeout: number = 2000
): boolean => {
  const isNetworkIdle = useNetworkIdle(timeout);
  const isReady = isNetworkIdle && !isDataLoading;

  useEffect(() => {
    window.reportPdfGeneration = isReady ? 'ready' : 'notReady';

    return () => {
      window.reportPdfGeneration = 'notReady';
    };
  }, [isReady]);

  return isReady;
};
